import { render } from "./AdminHomeView.vue?vue&type=template&id=0aa45983&scoped=true&ts=true&lang=pug"
import script from "./AdminHomeView.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdminHomeView.vue?vue&type=script&setup=true&lang=ts"

import "./AdminHomeView.vue?vue&type=style&index=0&id=0aa45983&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0aa45983"]])

export default __exports__